// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + {"344":"wordlist","480":"disclaimer","566":"oil-price","904":"beta","996":"gas-price"}[chunkId] + "." + {"344":"45679ade","480":"d160a745","566":"d7eebee7","904":"42bb2dac","996":"c60d3d54"}[chunkId] + ".js";
};